@if (triggersChartData$ | async; as chartData) {
  <div class="chart-wrapper">
    @if (
      chartData.get(chartType.TriggersOverspeedingDistribution);
      as triggersOverspeedDistribution
    ) {
      <div class="chart-wrapper__bar-chart">
        <div
          echarts
          class="chart-wrapper__bar-chart--content"
          [options]="triggersOverspeedDistribution"></div>
      </div>
    }
    <div class="chart-wrapper__radar-chart-group">
      @if (chartData.get(chartType.TriggersAbsolute); as triggersAbsolute) {
        <div>
          <div
            class="chart-wrapper__radar-chart-group--absolute"
            echarts
            [options]="triggersAbsolute"></div>
        </div>
      }
      @if (chartData.get(chartType.TriggersRelative); as triggersRelative) {
        <div
          class="chart-wrapper__radar-chart-group--relative"
          echarts
          [options]="triggersRelative"></div>
      }
    </div>
  </div>
}
